import { render, staticRenderFns } from "./GyroControl.vue?vue&type=template&id=630b1d59&"
import script from "./GyroControl.vue?vue&type=script&lang=js&"
export * from "./GyroControl.vue?vue&type=script&lang=js&"
import style0 from "./GyroControl.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports